import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

function Crud({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATABASE.SELECT.';

    return (
        <div>
            <div className="form-element">
                {t(label + 'QUERY')}
                <TextInput action={action} inputName="query" variables={variables} setOpenVariable={setOpenVariable} multiline isRequired={true} />
            </div>
            <div className="form-element">
                {t(label + 'TIMEOUT')}
                <TextInput action={action} inputName="timeout" variables={variables} setOpenVariable={setOpenVariable} />
            </div>
        </div>
    )
}

export default Crud;
